export default __webpack_public_path__ + "static/media/joseBertolino.f5b8a8c3.png";